import React from 'react';
import { Navigate } from 'react-router-dom';
import { useModules } from '../../context/ModuleContext';

/**
 * Route guard for a platform-scoped page.
 *
 * Routes stay registered whatever the module state, so an old bookmark always
 * resolves to something sensible rather than a blank screen:
 *
 *   module on                  render
 *   off, but was once on       render (the page puts itself in read-only mode)
 *   never enabled              redirect to the overview
 *
 * `requireWritable` is for pages that exist only to perform a write — the
 * order-placement flow — where a read-only rendering would just be a dead end.
 */
export default function ModuleRoute({ module, requireWritable = false, children }) {
    const { isVisible, canWrite } = useModules();

    if (!isVisible(module)) return <Navigate to="/reseller" replace />;
    if (requireWritable && !canWrite(module)) return <Navigate to="/reseller" replace />;

    return children;
}
